import { z } from 'zod/v4';

export const MarkDemoParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type MarkDemoParams = z.infer<typeof MarkDemoParamsSchema>;
